import LogicalOperator from "../../classes/consts/DataSourceModule/LogicalOperator";
import ComparisonOperators from "../../classes/consts/DataSourceModule/ComparisonOperators";
import FilterParameterDto from "../../classes/dtos/datasourcemodule/FilterParameterDto";
import FilterParameterValueDto from "../../classes/dtos/datasourcemodule/FilterParameterValueDto";
import FilterParameterVariableDto from "../../classes/dtos/datasourcemodule/FilterParameterVariableDto";
import GroupFilterDto from "../../classes/dtos/datasourcemodule/GroupFilterDto";

export { LogicalOperator, ComparisonOperators };

// ─── Helpers de narrowing ─────────────────────────────────────────────────────

export function isValue(p: FilterParameterDto): p is FilterParameterValueDto {
    return p instanceof FilterParameterValueDto;
}

export function isVariable(p: FilterParameterDto): p is FilterParameterVariableDto {
    return p instanceof FilterParameterVariableDto;
}

// ─── Id temporaire (nœuds/paramètres créés côté client avant sauvegarde) ─────

// Le back remplace entièrement Parameters.Filter à chaque sauvegarde (pas de patch
// incrémental), donc ces id n'ont besoin d'être uniques qu'au sein d'un même payload envoyé,
// pas stables dans le temps : de simples entiers négatifs décroissants suffisent, sans collision
// possible avec un id réel (toujours positif, auto-incrémenté côté base).
let nextId = -1;

export function nextTempId(): number {
    return nextId--;
}
